/** @file The selected event's default payload: int, float and string (event.setDefaults). */
import type { EventDoc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { NumberField } from '../../ui-kit/NumberField';
import { TextInput } from '../../ui-kit/TextInput';

/** One changed payload field, as event.setDefaults `value` takes it. */
export type EventPayload = Partial<Pick<EventDoc, 'int' | 'float' | 'string'>>;

/** Props of EventDefaults. */
export interface EventDefaultsProps {
  t: Translate;
  event: EventDoc;
  onChange: (value: EventPayload) => void;
}

/** Each committed field sends only itself; int keeps 0 decimals, float 4. */
export function EventDefaults({ t, event, onChange }: EventDefaultsProps) {
  return (
    <fieldset className="rig-fields">
      <legend>{t('panels.events.defaults')}</legend>
      <NumberField label={t('panels.events.int')} value={event.int} step={1} precision={0} onCommit={(int) => { onChange({ int }); }} />
      <NumberField label={t('panels.events.float')} value={event.float} step={0.1} precision={4} onCommit={(float) => { onChange({ float }); }} />
      <label className="rig-row">
        {t('panels.events.string')}
        <TextInput label={t('panels.events.string')} value={event.string} onCommit={(string) => { onChange({ string }); }} />
      </label>
    </fieldset>
  );
}
